module.exports = __webpack_public_path__ + "img/9.d26a5e7d.svg";